import { render, staticRenderFns } from "./consultProcesspingyi.vue?vue&type=template&id=098836d6&scoped=true&"
import script from "./consultProcesspingyi.vue?vue&type=script&lang=js&"
export * from "./consultProcesspingyi.vue?vue&type=script&lang=js&"
import style0 from "./consultProcesspingyi.vue?vue&type=style&index=0&id=098836d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098836d6",
  null
  
)

export default component.exports